import Modal from '../modal'; // Update with the correct path
import { showVideoModal } from '../../util/modal-helpers'; // Update with the correct path

class BlockGrid {
    constructor(el) {
        this.el = el;
        this.videoLinks = this.el.querySelectorAll('.block-grid__items .block-link-video');

        console.log('grid');

        this.attachVideoLinkListeners();
        this.equalizeColumnHeights();

        this.resizeTimeout = null;
        window.addEventListener('resize', () => {
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(() => {
                this.equalizeColumnHeights();
            }, 300);
        });
    }

    attachVideoLinkListeners() {
        this.videoLinks.forEach(link => {
            link.addEventListener('click', event => {
                event.preventDefault();

                const videoUrl = link.getAttribute('href');
                this.showVideoModal(videoUrl);
            });
        });
    }

    showVideoModal(videoUrl) {
        showVideoModal(videoUrl);
    }

    equalizeColumnHeights() {
        const columns = this.el.querySelectorAll('.block-grid__items .columns');

        columns.forEach(column => {
            column.style.minHeight = ''; // Reset min-height before recalculating
        });

        let maxHeight = 0;
        columns.forEach(column => {
            const columnHeight = column.clientHeight;
            if (columnHeight > maxHeight) {
                maxHeight = columnHeight;
            }
        });

        columns.forEach(column => {
            column.style.minHeight = `${maxHeight}px`;
        });
    }
}

export default BlockGrid;
